export const SpecialOrderTableHeaders=[
    {
        Header:'Order#',
        accessor:'orderNumber'
    },
    {
        Header:'Style',
        accessor:'style'
    },
    
    {
        Header:'Company',
        accessor:'company'
    },
    {
        Header:'Color',
        accessor:'color'
    },
    {
        Header:'US Size',
        accessor:'USSize'
    },
    {
        Header:'Name',
        accessor:'name'
    },
    {
        Header:'Last Name',
        accessor:'lastname'
    },
    {
        Header:'Phone',
        accessor:'phone'
    }, 
    {
        Header:'Order Date',
        accessor:'startDate'
    },
    {
        Header:'Arrival Date',
        accessor:'arrivalDate'
    },
    {
        Header:'Event Date',
        accessor:'eventDate'
    },
    {
        Header:'Cost',
        accessor:'cost'
    },
    {
        Header:'Price',
        accessor:'price'
    },
    {
        Header:'Location',
        accessor:'location'
    }
]